// Recupero da ChunkLoadError dopo un nuovo deploy.
//
// Con React.lazy, il build genera file chunk con hash nel nome. Dopo un deploy
// i nomi cambiano: un browser (tipicamente mobile) che tiene in memoria la
// pagina vecchia prova a caricare un chunk non più esistente -> l'import()
// fallisce -> senza ErrorBoundary si vede una schermata bianca.
//
// Soluzione: al fallimento di un chunk forziamo UN ricaricamento hard della
// pagina per scaricare l'HTML e gli asset aggiornati. Un guard temporale evita
// loop infiniti (ricarica al massimo una volta ogni 10s).

export const isChunkLoadError = (error) => {
  const name = error?.name || "";
  const msg = error?.message || "";
  return (
    name === "ChunkLoadError" ||
    /Loading chunk|Loading CSS chunk|dynamically imported module|Failed to fetch dynamically imported/i.test(msg)
  );
};

export const tryReloadOnce = () => {
  const KEY = "chunk_reload_ts";
  try {
    const last = parseInt(sessionStorage.getItem(KEY) || "0", 10);
    if (Date.now() - last > 10000) {
      sessionStorage.setItem(KEY, String(Date.now()));
      window.location.reload();
      return true;
    }
  } catch (e) {
    // sessionStorage non disponibile: ricarica comunque una volta
    window.location.reload();
    return true;
  }
  return false;
};
